import { render, staticRenderFns } from "./MagazineProductMark.vue?vue&type=template&id=834ca7c2&scoped=true&"
import script from "./MagazineProductMark.vue?vue&type=script&lang=js&"
export * from "./MagazineProductMark.vue?vue&type=script&lang=js&"
import style0 from "./MagazineProductMark.vue?vue&type=style&index=0&id=834ca7c2&scoped=true&lang=css&"
import style1 from "./MagazineProductMark.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834ca7c2",
  null
  
)

export default component.exports